module.exports = __webpack_public_path__ + "img/iraq.e6713875.png";